import {Component} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MensagemService} from '../../../shared/services/mensagem.service';
import {Util} from '../../../../../utils/util';

@Component({
    selector: 'app-modal-responder-solicitacao',
    templateUrl: './modal-responder-solicitacao.page.html',
    styleUrls: ['./modal-responder-solicitacao.page.scss'],
})
export class ModalResponderSolicitacaoPage {

    tipoSolicitacao = '';

    public modalForm: FormGroup;
    public validationMessages = {
        justificativa: [
            {type: 'required', message: 'Justificativa é obrigatório.'}
        ],
        tipoSolicitacao: [
            {type: 'required', message: 'Solicitacao é obrigatório.'}
        ]
    };

    constructor(
        private modalController: ModalController,
        private formBuilder: FormBuilder,
        private mensagemService: MensagemService
    ) {
        this.modalForm = this.formBuilder.group({
            id: [''],
            tipoSolicitacao: [''],
            justificativa: ['', Validators.required],
        }, {updateOn: 'blur'});
    }

    async enviar(opcao) {
        this.salvar();
    }

    async salvar() {
        if (this.modalForm.valid) {
            console.log('this.modalForm.getRawValue(): ', this.modalForm.getRawValue());
            await this.modalController.dismiss(true);
        } else {
            Util.touchAllControls(this.modalForm);
            await this.mensagemService.showToast('Preencha os campos corretamente.');
        }
    }

    async fechar(opcao) {
        await this.modalController.dismiss(true);
    }
}
